import axiosClient from "./axiosClient";

export const addNotification = async (newNotification) => {
    try {
        const response = await axiosClient.post("/notifications", newNotification, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data; // Return API response
    } catch (error) {
        console.error("Error adding notification:", error.response?.data || error.message);
        throw error;
    }
};

export const fetchNotifications = async () => {
    try {
        const response = await axiosClient.get("/notifications", {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data; // Return API response
    } catch (error) {
        console.error("Error fetching notifications:", error.response?.data || error.message);
        throw error;
    }
};

export const markNotificationAsRead = async (notificationId) => {
    try {
        const response = await axiosClient.put(`/notifications/${notificationId}/read`, {}, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data; // Return API response
    } catch (error) {
        console.error("Error marking notification as read:", error.response?.data || error.message);
        throw error;
    }
};
